import * as React from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  FlatList,
} from "react-native";
import { Color, globalFontStyle } from "../assets";
import FastImage from "../common/FastImage";
import { down_arrow, up_arrow } from "../utils/images";
import {globalConfigurableData} from "../utils/globalConstant";
import FormTextLabel from "./FormTextLabel";

const InDepthAccordian = ({ setLiveRankInDepth, liveRankInDepthShow }) => {
  return (
    <TouchableOpacity
      onPress={() => {
        setLiveRankInDepth(!liveRankInDepthShow);
      }}
    >
      <View
        style={{
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          height: 35,
          borderTopWidth: 0.75,
          borderTopColor: Color.borderColor,
        }}
      >
        <FormTextLabel
          labelStyles={{
            color: Color.black,
            ...globalFontStyle.appFontSubText,
            marginRight: 5,
          }}
          label={!liveRankInDepthShow ? "View in depth" : "Collapse"}
        />
        <FastImage
          source={liveRankInDepthShow ? globalConfigurableData?.up_arrow() : globalConfigurableData?.down_arrow()}
          style={{ width: 15, height: 15 }}
        />
      </View>
    </TouchableOpacity>
  );
};

export default InDepthAccordian;
